/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, Paper, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import { Group, ExpandMore } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import { format } from 'date-fns';


import PresenceGraph from '../../../components/Graphics/PresenceGraph';
import DataTable from '../../../components/DataTable/DataTable';


class PresenceChart extends React.Component {
  state = {
    defaultList: [],
    presenceData: [],
    presenceInfo: null,
    selectedSlice: null,
    activeStep: 0,
    appointmentTime: new Date()
  };

  componentDidMount() {
    if (this.props.data) {
      this.fetchPresences();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
      this.fetchPresences();
    }
  }

  onClickSlice = (sliceInfo) => {
    if (sliceInfo.id == 'Estão na empresa') {
      this.setState({ activeStep: sliceInfo.arc.index });
    } else if (sliceInfo.id == 'Não estão na empresa') {
      this.setState({ activeStep: sliceInfo.arc.index });
    } else {
      this.setState({ activeStep: sliceInfo.arc.index });
    }
  }

  setPieConfig = (list) => {
    let inCompany = list.inCompany.length;
    let outCompany = list.outCompany.length;
    let absencesCompany = list.absencesCompany.length;

    const infoConfig = [
      {
        id: 'Estão na empresa', label: 'Estão na empresa', value: inCompany, color: '#79D478',
      },
      {
        id: 'Não estão na empresa', label: 'Não estão na empresa', value: outCompany, color: '#F76363',
      },
      {
        id: 'Não vieram hoje', label: 'Não vieram hoje', value: absencesCompany, color: '#FCA95C',
      }
    ];

    return infoConfig;
  }

  fetchPresences = () => {
    const response = this.props.data;

    let employeeList = [];

    if (response) {
      employeeList = response;

      this.setState({
        presenceData: employeeList,
        presenceInfo: this.setPieConfig(employeeList),
        selectedSlice: null,
      });
    }
  }

  initializeDateItemForm = (item) => {
    if (item) {
      item
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/');
      const hour = item.split('T')[1].split('.')[0];

      return `${hour}`;
    }
    return '';
  };

  renderListInCompany = () => {
    const absencesColumns = [
      { name: 'name', label: 'Nome' },
      { name: 'dtHour', label: 'Entrada' },
    ];

    const info = this.state.presenceData?.inCompany?.map(i => ({
      ...i,
      dtHour: this.initializeDateItemForm(i.dtRegister),
      name: (
        <div>
          <div style={{
            background: '#79D478', width: 10, height: 10, borderRadius: 50, padingRigth: 10, display: 'inline-block',
          }}
          />
          <span>
            {'    '}{i.employee.name}
          </span>
        </div>
      ),
    }));

    return (
      <DataTable
        rows={info || []}
        columns={absencesColumns}
        outRowsPerPage={5}
        pagination
      />
    );
  }

  renderListOutCompany = () => {
    const absencesColumns = [
      { name: 'name', label: 'Nome' },
      { name: 'dtHour', label: 'Saida' },
    ];

    const info = this.state.presenceData?.outCompany?.map(i => ({
      ...i,
      dtHour: this.initializeDateItemForm(i.dtRegister),
      name: (
        <div>
          <div style={{
            background: '#F76363', width: 10, height: 10, borderRadius: 50, padingRigth: 10, display: 'inline-block',
          }}
          />
          <span>
            {'    '}{i.employee.name}
          </span>
        </div>
      ),
    }));

    return (
      <DataTable
        rows={info || []}
        columns={absencesColumns}
        pagination
      />
    );
  }

  renderListAbsencesCompany = () => {
    const absencesColumns = [
      { name: 'name', label: 'Nome' },
    ];

    const info = this.state.presenceData?.absencesCompany?.map(i => ({
      ...i,
      name: (
        <div>
          <div style={{
            background: '#FCA95C', width: 10, height: 10, borderRadius: 50, padingRigth: 10, display: 'inline-block',
          }}
          />
          <span>
            {'    '}{i.name}
          </span>
        </div>
      ),
    }));

    return (
      <DataTable
        rows={info || []}
        columns={absencesColumns}
        pagination
      />
    );
  }

  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <Grid>
            <Typography style={{ textAlign: 'center', marginTop: '5px', marginBottom: '-12px' }}>Estão na empresa</Typography>
            <ExpansionPanelDetails style={{ padding: 0 }}>
              {this.renderListInCompany()}
            </ExpansionPanelDetails>
          </Grid>
        );
      case 1:
        return (
          <Grid>
            <Typography style={{ textAlign: 'center', marginTop: '5px', marginBottom: '-12px' }}>Não estão na empresa</Typography>
            <ExpansionPanelDetails style={{ padding: 0 }}>
              {this.renderListOutCompany()}
            </ExpansionPanelDetails>
          </Grid>
        );
      case 2:
        return (
          <Grid>
            <Typography style={{ textAlign: 'center', marginTop: '5px', marginBottom: '-12px' }}>Não vieram hoje</Typography>
            <ExpansionPanelDetails style={{ padding: 0 }}>
              {this.renderListAbsencesCompany()}
            </ExpansionPanelDetails>
          </Grid>
        );

    }
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid>
        <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} className={classes.paperGraphics} data-tut="reactour__Faltantes">
          <Typography
            variant="h6"
            component="h4"
            color="textSecondary"
            align="left"
            style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
          >
            {`Presentes e Ausentes às ${format(new Date(this.state.appointmentTime), 'HH:mm')}`}
          </Typography>

          <div
            style={{
              height: 300,
              //minWidth: 300,
              padding: '10px',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              cursor: !this.state.presenceInfo ? 'default' : 'pointer',
            }}
          >
            {
              !this.state.presenceInfo ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Group color="disabled" style={{ fontSize: 100, paddingBottom: 20 }} />
                  <Typography component="h3" color="textSecondary" align="center">
                    Nenhum funcionário a ser exibido
                  </Typography>
                </div>
              ) :
                <PresenceGraph data={this.state.presenceInfo} onClick={this.onClickSlice} selectedSlice={this.state.selectedSlice} />
            }
          </div>
        </Paper>
        <ExpansionPanel style={{ marginTop: 0 }} >
          <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }}>
            <Typography className={classes.heading}> Ver Detalhes </Typography>
          </ExpansionPanelSummary>
          {this.getStepContent(this.state.activeStep)}
        </ExpansionPanel>
      </Grid>
    );
  }
}

export default PresenceChart;
